export function getDeviceHeight(resourceType) {
    switch (resourceType) {
        case 'Energy Bar':
            return 120;
        case 'Energy Spider':
            return 100;
        case 'Energy Spider Flex':
            return 80;
        default:
            return 0;
    }
}
function getSpiderFlexPortPosition(port) {
    switch (port) {
        case 1:
            return { x: 0, y: 18.5 };
        case 2:
            return { x: 0, y: 61.5 };
        case 3:
            return { x: 50, y: 18.5 };
        case 4:
            return { x: 50, y: 61.5 };
        default:
            return { x: 0, y: 0 };
    }
}
function getSpiderPortPosition(port) {
    switch (port) {
        case 1:
            return { x: 0, y: 16.5 };
        case 2:
            return { x: 0, y: 38.5 };
        case 3:
            return { x: 0, y: 61.5 };
        case 4:
            return { x: 0, y: 83.5 };
        case 5:
            return { x: 50, y: 16.5 };
        case 6:
            return { x: 50, y: 38.5 };
        case 7:
            return { x: 50, y: 61.5 };
        case 8:
            return { x: 50, y: 83.5 };
        default:
            return { x: 0, y: 0 };
    }
}
function getBarPortPosition(port) {
    switch (port) {
        case 1:
            return 13;
        case 2:
            return 32;
        case 3:
            return 51;
        case 4:
            return 69;
        case 5:
            return 88;
        case 6:
            return 107;
        default:
            return 13;
    }
}
export function getPortPosition(busDevice, reversed = false) {
    switch (busDevice.resourceType) {
        case 'Energy Bar':
            // 50 x 120, ports 1-6
            return {
                x: reversed ? 10.5 : 38.5,
                y: getBarPortPosition(busDevice.port),
            };
        case 'Energy Spider':
            // 50 x 100, ports 1-8
            return getSpiderPortPosition(busDevice.port);
        case 'Energy Spider Flex':
            // 50 x 80, ports 1-4
            return getSpiderFlexPortPosition(busDevice.port);
        default:
            return { x: 0, y: 20 };
    }
}
export function getBreakerPosition(column, slotPosition) {
    return {
        x: (column - 1) * 140,
        y: (slotPosition - 1) * 30,
    };
}
export function getBreakerPolePosition(column, slotPosition, pole = 1) {
    const offsetX = column === 1 ? 0 : 124;
    const { x, y } = getBreakerPosition(column, slotPosition);
    return {
        x: x + offsetX,
        y: y + pole + 13 + (pole - 1) * 28,
    };
}
export function getMainBreakerPolePosition(pole, panelType) {
    const offsetX = panelType === 'US_VERTICAL_THREE_PHASE' ? 58 : 0;
    return {
        x: 181 + offsetX + (pole - 1) * 28,
        y: 14,
    };
}
